import { createSelector } from 'reselect';

const selectGatewayRegistries = (state: any) => state.gatewayRegistries;


export const selectGatewayRegistriesCurrentItem = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.current);

export const selectGatewayRegistriesListItems = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.list);

export const selectGatewayRegistriesItemById = (itemId: any) =>
    createSelector(selectGatewayRegistriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGatewayRegistriesQueryItems = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.query);

export const selectGatewayRegistriesCreatedItem = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.create);

export const selectGatewayRegistriesUpdatedItem = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.update);

export const selectGatewayRegistriesReadItem = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.read);

export const selectGatewayRegistriesDeletedItem = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.delete);

export const selectGatewayRegistriesSearchedItems = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.search);

export const selectGatewayRegistriesItemsCount = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.count);

export const selectGatewayRegistriesItemsFilter = createSelector([selectGatewayRegistries], (gatewayRegistries) => gatewayRegistries.filter);